import { formatGericParsedDataConnectionResource } from "areas/verifications/helpers/generic-parsed-data";
import { LightspeedBlack } from "ui-kit/icon";
import { IIngestionSourceData } from './types';

const loginUrl = "https://us.merchantos.com/?name=item.listings.items&form_name=listing&shop_id=1&disp_year=off&show_catalog_results=off&description=&tags=maxretail&neg_tags=&show_all_shops=off&qoh_positive=off&qoh_zero=off&archived=off&category_id=-1&manufacturer_id=-1&vendor_id=-1&item_type=-1&serialized=-1&item_attribute_set_id=-1&search_class_id=-1&__sort=description&__sort_dir=ASC"

const lightspeed: IIngestionSourceData = {
  displayName: "Lightspeed",
  isEcom: true,
  isAutomated: true,
  parsedDataFormatter: formatGericParsedDataConnectionResource,
  loginUrl,
  inventoryReminder: {
    buttonText: "OK, I will adjust my inventory",
    text: "Don't forget to adjust your Lightspeed inventory to reflect this Max Retail sale!",
    titleText: "Lightspeed Inventory Reminder",
    linkText: "Lightspeed Dashboard",
    linkHref: loginUrl
  },
  listInventory: {
    linkHref: loginUrl,
    icon: LightspeedBlack
  },
  cannotUpdateListing: {
    text: "To update this item, you need to edit it in your Lightspeed account.",
    linkHref: loginUrl
  },
  listingsSubheader: {
    text:
      "You're connected to Lightspeed! While you can view your listings here, you can only make changes in your Max Retail collection via ",
    linkHref: loginUrl
  },
  errorReport: {
    getFixLinkHref: (productId: string) => {
      if (!productId)
        return "https://us.merchantos.com/?name=item.listings.items&form_name=listing&shop_id=1&disp_year=off&show_catalog_results=off&description=&tags=maxretail&neg_tags=&show_all_shops=off&qoh_positive=off&qoh_zero=off&archived=off&category_id=-1&manufacturer_id=-1&vendor_id=-1&item_type=-1&serialized=-1&item_attribute_set_id=-1&search_class_id=-1&__sort=description&__sort_dir=ASC";
      const [martixOrIndex, itemId] = productId.split("-");
      if (martixOrIndex === "matrix") {
        return `https://us.merchantos.com/?name=item_group.views.item_group&form_name=view&id=${itemId}&tab=matrix`;
      }
      if (martixOrIndex === "item") {
        return `https://us.merchantos.com/?name=item.views.item&form_name=view&id=${itemId}&tab=details`;
      }
      return `https://us.merchantos.com/?name=item.listings.items&form_name=listing&shop_id=1&disp_year=off&show_catalog_results=off&description=&tags=maxretail&neg_tags=&show_all_shops=off&qoh_positive=off&qoh_zero=off&archived=off&category_id=-1&manufacturer_id=-1&vendor_id=-1&item_type=-1&serialized=-1&item_attribute_set_id=-1&search_class_id=-1&__sort=description&__sort_dir=ASC;`;
    },
    listHref: "https://admin.lightspeed.com/products/new"
  }
};

export default lightspeed